import { createStyles } from '@udecode/plate-styled-components';
import _styled, { css } from 'styled-components';
import React from 'react';
import Tippy from '@tippyjs/react';
import { useReadOnly, useSelected } from 'slate-react';

const getPopoverStyles = props => createStyles({
  prefixClassNames: 'Popover',
  ...props
}, {
  root: [{
    "display": "flex",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }, css(["border-radius:3px;max-width:350px;font-size:14px;box-shadow:rgba(9,30,66,0.31) 0 0 1px,rgba(9,30,66,0.25) 0 4px 8px -2px;"])]
});

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const Popover = ({
  rootProps,
  content,
  ...props
}) => {
  // const editor = useSlate();
  // const isSelectionCollapsed = isCollapsed(editor.selection);
  const readOnly = useReadOnly();
  const selected = useSelected();
  const tippyProps = {
    animation: '',
    arrow: false,
    delay: [0, 0],
    duration: [0, 0],
    interactive: true,
    offset: [0, 12],
    placement: 'bottom',
    theme: 'custom',
    visible: !readOnly && selected,
    render: attrs => {
      const {
        root
      } = getPopoverStyles(props);
      return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, attrs, {
        contentEditable: false,
        onMouseDown: e => {
          e.preventDefault();
        },
        className: root.className
      }, rootProps, {
        $_css: root.css
      }), content);
    }
  };
  return /*#__PURE__*/React.createElement(Tippy, _extends({}, tippyProps, props));
};

var _StyledDiv = _styled("div").withConfig({
  displayName: "Popover___StyledDiv",
  componentId: "sc-q0u1f-0"
})(["", ""], p => p.$_css);

export { Popover, getPopoverStyles };
//# sourceMappingURL=index.es.js.map
